import isIos from './is-ios'
import isAndroid from './is-android'

export default { isAndroid, isIos }
